import type { FragmentType, Id } from '@e-socna/data-layer';

import { buildSelectedGroupsTotalCalculation } from '../../../components/ServiceUsages/TotalCard/utils/selected-groups-total.util';
import type { ServiceUsagesTotalCardCmp_TotalCalculation_Fragment } from '../../../components/ServiceUsages/TotalCard';
import type { GroupTotalCalculationMap } from '../../../utils/build-group-total-calculation-map.util';

type PricedGroup = Readonly<{
  _id: Id;
  isOptional?: boolean | null;
}>;

const isGroupSelected = (
  group: PricedGroup,
  selectedOptionGroupIds: readonly Id[] | null | undefined,
) =>
  !group.isOptional ||
  !selectedOptionGroupIds ||
  selectedOptionGroupIds.includes(group._id);

// The total of a sub-mission within its collaboration: the sum of its group
// totals computed by the collaboration, its unselected options left out, so
// that the sub-mission totals add up to the global total.
export const buildSubMissionTotalCalculation = ({
  groups,
  groupTotalCalculationMap,
  selectedOptionGroupIds,
}: Readonly<{
  groups: readonly PricedGroup[];
  groupTotalCalculationMap: GroupTotalCalculationMap;
  selectedOptionGroupIds: readonly Id[] | null | undefined;
}>): FragmentType<
  typeof ServiceUsagesTotalCardCmp_TotalCalculation_Fragment
> | null =>
  buildSelectedGroupsTotalCalculation(
    groupTotalCalculationMap,
    groups
      .filter((group) => isGroupSelected(group, selectedOptionGroupIds))
      .map((group) => group._id),
  );
